
import {Prop, Vue} from "vue-property-decorator";
import CalendarIcon from "@/assets/icons/icon-calendar.svg?inline";
import TrophyIcon from "@/assets/icons/icon-trophy.svg?inline";
import {Options} from "vue-class-component";

const ButtonStates = {
  APPLY: 'apply',
  CLOSED: 'closed',
  COMING_SOON: 'comingSoon'
}

type ButtonState = typeof ButtonStates[keyof typeof ButtonStates]

@Options({
  components: {CalendarIcon, TrophyIcon}
})

export default class ChallengeCard extends Vue {

  @Prop({
    type: String,
  })
  public image!: string;

  @Prop({
    type: String,
  })
  public startDate!: string;

  @Prop({
    type: String,
  })
  public startDateRaw!: string;

  @Prop({
    type: String,
  })
  public endDate!: string;

  @Prop({
    type: String,
  })
  public endDateRaw!: string;

  @Prop({
    type: String,
  })
  public title!: string;

  @Prop({
    type: String,
  })
  public description!: string;

  @Prop({
    type: String,
  })
  public valued!: string;

  @Prop({
    type: String,
  })
  public applyUrl!: string;

  @Prop({
    type: String,
  })
  public discoverUrl!: string;

  get formattedValue() {
    return `$${parseFloat(this.valued).toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).replace(',', '.')}`;
  }

  get ButtonStates() {
    return ButtonStates;
  }

  get buttonState(): ButtonState {
    const currentDate = new Date();
    const startDate = new Date(this.startDateRaw);
    const endDate = new Date(this.endDateRaw);

    if (currentDate > endDate) {
      return ButtonStates.CLOSED;
    }
    if (currentDate >= startDate) {
      return ButtonStates.APPLY;
    }
    return ButtonStates.COMING_SOON;
  }
}
